module.exports = __webpack_public_path__ + "img/img12.2ba96a0c.jpg";